






































import Vue from 'vue'
import { mapActions } from 'vuex'

/* eslint-disable */ 
import { Dealer } from '../models/Dealer'
/* eslint-enable */ 

export default Vue.extend({
  name: 'ResetPassword',

  data: () => {
    return {
      requestForm: {
        email: '',
        dealer_id: 0
      },
      resetForm: {
        email: '',
        dealer_id: 0,
        verification_code: null,
        password: '',
        password_confirmation: '',
      },
      snackbar: false,
      snackbarText: '',
      requesting: true
    }
  },
  computed: {
    currentDealer() : Dealer {
      return this.$store.state.dealers.currentDealer
    },
    obs () : any {
      return this.$refs.observer as any
    }
  },
  methods: {
    ...mapActions({
      resetPasswordRequest: 'auth/resetPasswordRequest',
      resetPassword: 'auth/resetPassword'
    }),
    async requestCode () {
      this.requestForm.dealer_id = this.currentDealer.id
      const isValid = await this.obs.validate()
      if (isValid) {
        await this.resetPasswordRequest(this.requestForm)
        this.snackbarText = 'If a user with this e-mail exists in our system, a password reset verification code will be sent.'
        this.snackbar = true
        this.requesting = false 

      } else {
        this.snackbarText = 'Please enter a valid e-mail address.'
        this.snackbar = true
      }
    },
    async submitResetPassword () {
      this.resetForm.dealer_id = this.currentDealer.id
      this.resetForm.email = this.requestForm.email
      const isValid = await this.obs.validate()
      if (isValid) {
        const check = await this.resetPassword(this.resetForm)
        if (check != -1) {
          this.snackbarText = 'Your password has been reset. Please log in with the new password.'
          this.snackbar = true
          this.$router.push('/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode + '/login')
        } else {
          this.snackbarText = 'There was an error processing your request. Please try again.'
          this.snackbar = true
        }
      }
    }
  }
})
